"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Link = require("./Link");

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginForm = function LoginForm(_ref) {
  var _ref$Link = _ref.Link,
      Link = _ref$Link === undefined ? _Link2.default : _ref$Link,
      _ref$formAction = _ref.formAction,
      formAction = _ref$formAction === undefined ? "/post/login" : _ref$formAction,
      username = _ref.username,
      usernameError = _ref.usernameError,
      passwd = _ref.passwd,
      passwdError = _ref.passwdError,
      rememberMe = _ref.rememberMe,
      resetPasswordUrl = _ref.resetPasswordUrl,
      onChangeRememberMe = _ref.onChangeRememberMe,
      onChangeUsername = _ref.onChangeUsername,
      onChangePasswd = _ref.onChangePasswd,
      onLogin = _ref.onLogin;
  return _react2.default.createElement(
    "form",
    {
      action: formAction,
      className: "form-v2",
      id: "login-form",
      method: "post",
      name: "login-form",
      onSubmit: onLogin
    },
    _react2.default.createElement("input", { name: "op", type: "hidden", defaultValue: "login" }),
    _react2.default.createElement("input", {
      name: "dest",
      type: "hidden",
      defaultValue: "/"
    }),
    _react2.default.createElement(
      "div",
      { className: "c-form-group" },
      _react2.default.createElement(
        "label",
        { className: "screenreader-only", htmlFor: "user_login" },
        "username:"
      ),
      _react2.default.createElement("input", {
        autoFocus: true,
        className: "c-form-control",
        id: "user_login",
        maxLength: 20,
        name: "user",
        placeholder: "username",
        tabIndex: 3,
        type: "text",
        defaultValue: username,
        onChange: function onChange(e) {
          return onChangeUsername(e.target.value);
        }
      }),
      _react2.default.createElement(
        "div",
        { className: "c-form-control-feedback-wrapper" },
        usernameError ? _react2.default.createElement("span", { className: "c-form-control-feedback c-form-control-feedback-error", title: usernameError, style: { display: "block" } }) : null
      )
    ),
    _react2.default.createElement(
      "div",
      { className: "c-form-group" },
      _react2.default.createElement(
        "label",
        { className: "screenreader-only", htmlFor: "passwd_login" },
        "password:"
      ),
      _react2.default.createElement("input", {
        className: "c-form-control",
        id: "passwd_login",
        name: "passwd",
        placeholder: "password",
        tabIndex: 3,
        type: "password",
        defaultValue: passwd,
        onChange: function onChange(e) {
          return onChangePasswd(e.target.value);
        }
      }),
      _react2.default.createElement(
        "div",
        { className: "c-form-control-feedback-wrapper" },
        passwdError ? _react2.default.createElement("span", { className: "c-form-control-feedback c-form-control-feedback-error", title: passwdError, style: { display: "block" } }) : null
      )
    ),
    onChangeRememberMe || resetPasswordUrl ? _react2.default.createElement(
      "div",
      { className: "c-checkbox" },
      onChangeRememberMe ? _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement("input", {
          id: "rem_login",
          name: "rem",
          tabIndex: 3,
          type: "checkbox",
          checked: rememberMe,
          onChange: onChangeRememberMe
        }),
        _react2.default.createElement(
          "label",
          { htmlFor: "rem_login" },
          "remember me"
        )
      ) : null,
      resetPasswordUrl ? _react2.default.createElement(
        Link,
        { className: "c-pull-right", href: resetPasswordUrl },
        "reset password"
      ) : null
    ) : null,
    _react2.default.createElement(
      "div",
      { className: "c-clearfix c-submit-group" },
      _react2.default.createElement(
        "button",
        {
          className: "c-btn c-btn-primary c-pull-right",
          tabIndex: 3,
          type: "submit"
        },
        "log in"
      )
    ),
    _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement("div", { className: "c-alert c-alert-danger" })
    )
  );
};

exports.default = LoginForm;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/LoginForm.js
// module id = 318
// module chunks = 0